import { render, staticRenderFns } from "./gestao.vue?vue&type=template&id=55a48fd1&scoped=true"
import script from "./gestao.vue?vue&type=script&lang=js"
export * from "./gestao.vue?vue&type=script&lang=js"
import style0 from "./gestao.vue?vue&type=style&index=0&id=55a48fd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a48fd1",
  null
  
)

export default component.exports